export default __webpack_public_path__ + "static/media/29.f4756641.png";